import { AddressSearchModule } from '@anb/ng-address-search';
import { AnbFormElementsModule } from '@anb/ng-forms';
import { KadasterModule } from '@anb/ng-kadaster';
import { MapModule } from '@anb/ng-maps';
import { MapUtilModule } from '@anb/ng-maps-util';
import { AnbModal, AnbUIElementsModule } from '@anb/ng-ui';
import { CommonModule, CurrencyPipe, registerLocaleData } from '@angular/common';
import localeNlExtra from '@angular/common/locales/extra/nl';
import localeNl from '@angular/common/locales/nl';
import { LOCALE_ID, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NgxPermissionsModule } from 'ngx-permissions';
import { AanvraagOverzichtComponent } from './components/aanvraag-overzicht/aanvraag-overzicht.component';
import { FormSubtitleComponent } from './components/form-subtitle/form-subtitle.component';
import { HeaderpictureComponent } from './components/headerpicture/headerpicture.component';
import { LinkComponent } from './components/link/link.component';
import { TitleComponent } from './components/title/title.component';
import { WorkflowRouteDirective } from './directives/workflow-route.directive';
import { BijlageTypeDescriptionPipe } from './pipes/bijlage-type-description.pipe';
import { LabelRequirednPipe } from './pipes/label.pipe';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { StatusDescriptionPipe } from './pipes/status-description.pipe';
import { FormValidatorService } from './services/form-validator.service';

registerLocaleData(localeNl, 'nl-BE', localeNlExtra);

@NgModule({
  declarations: [
    LinkComponent,
    FormSubtitleComponent,
    HeaderpictureComponent,
    TitleComponent,
    WorkflowRouteDirective,
    LabelRequirednPipe,
    BijlageTypeDescriptionPipe,
    StatusDescriptionPipe,
    AanvraagOverzichtComponent,
    SafeHtmlPipe
  ],
  imports: [
    CommonModule,
    AnbUIElementsModule,
    AnbFormElementsModule,
    RouterModule,
    ReactiveFormsModule,
    MapModule,
    MapUtilModule,
    AddressSearchModule,
    KadasterModule,
    TranslateModule,
  ],
  exports: [
    NgxPermissionsModule,
    AnbUIElementsModule,
    AnbFormElementsModule,
    RouterModule,
    ReactiveFormsModule,
    MapModule,
    MapUtilModule,
    AddressSearchModule,
    KadasterModule,
    LinkComponent,
    FormSubtitleComponent,
    HeaderpictureComponent,
    TitleComponent,
    WorkflowRouteDirective,
    LabelRequirednPipe,
    AanvraagOverzichtComponent,
    BijlageTypeDescriptionPipe,
    TranslateModule,
    SafeHtmlPipe
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'nl-BE' },
    AnbModal,
    BijlageTypeDescriptionPipe,
    StatusDescriptionPipe,
    FormValidatorService,
    CurrencyPipe,
    SafeHtmlPipe
  ],
})
export class SharedModule { }
